import { lazy } from "react";

// LAZY CUSTOMER COMPONENTS
//InputPageComponent
export const JourneyLeadDetails = lazy(
  () => import("customer/journey/input/leadDetails")
);
export const JourneyCattleDetails = lazy(
  () => import("customer/journey/input/cattleDetails")
);
export const FireDetails = lazy(
  () => import("customer/journey/input/fireDetails")
);

export const JourneyGadgetInputDetails = lazy(
  () => import("customer/journey/input/gadgetDetails")
);
export const JourneyCyberDetails = lazy(
  () => import("customer/journey/input/cyberDetails")
);
export const JourneyCreditLifeInputDetails = lazy(
  () => import("customer/journey/input/creditLifeDetails")
);

export const JourneyIndemnityDetails = lazy(
  () => import("customer/journey/input/indemnityDetails")
);

export const JourneyPropertyInputDetails = lazy(
  () => import("customer/journey/input/propertyDetails")
);

export const JourneyPetDetails = lazy(
  () => import("customer/journey/input/petDetails")
);

export const JourneySelectMembers = lazy(
  () => import("customer/journey/input/selectMembers")
);

export const JourneyTravelDetails = lazy(
  () => import("customer/journey/input/travelDetails")
);

export const JourneyFireDetailsPage = lazy(
  () => import("customer/journey/input/fireDetails")
);
//
export const JourneyMarineDetails = lazy(
  () => import("customer/journey/input/marineDetails")
);

export const JourneyInputTransitDetails = lazy(
  () => import("customer/journey/input/transportDetails")
);

export const InputTransitDetails = lazy(
  () => import("customer/journey/input/transportDetails")
);

export const JourneyQuotesPage = lazy(() => import("customer/journey/quotes"));

export const JourneyProposalPage = lazy(
  () => import("customer/journey/proposal")
);
export const InputsPageRender = lazy(
  () => import("customer/journey/InputsPageRender")
);
export const JourneyProposalSummaryPage = lazy(
  () => import("customer/journey/proposalSummary")
);
export const JourneyPaymentGatewayPage = lazy(
  () => import("customer/journey/paymentGateway")
);
export const JourneyThankyouPage = lazy(
  () => import("customer/journey/thankyou")
);
export const JourneyComparePage = lazy(
  () => import("customer/journey/compare")
);
export const JourneyLandingPage = lazy(
  () => import("customer/journey/LandingPage")
);
